























































































import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/modules/home/components/Navbar.vue";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({
  components: {
    navbar: Navbar,
  },
})
export default class ChangePassword extends Vue {
  @Auth.Action("changePassword") changePasswordAction!: (
    payload: { userId: string; token: string; newPassword: string; confirmPassword: string }
  ) => Promise<{}>;

  loading = false;
  changeSent = false;
  changePassword = {
    userId: "",
    token: "",
    newPassword: "",
    confirmPassword: "",
  };

  mounted() {
    const { userId, token } = this.$route.query;
    if (!userId || !token) {
      this.$router.push('/login');
    } else {
      this.changePassword.userId = userId.toString();
      this.changePassword.token = token.toString();
    }
  }

  confirmChangePassword() {
    this.loading = true;
    this.changePasswordAction(this.changePassword)
      .then(() => {
        this.loading = false;
        this.changeSent = true;
      })
      .catch(() => {
        this.loading = false;
        this.changeSent = false;
      });
  }

  validations() {
    return {
      changePassword: {
        newPassword: {
          required,
          minLength: minLength(6),
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs("newPassword"),
        },
      },
    };
  }
}
